import React from "react";
import {
  Upload,
  Form,
  Icon,
  Select,
  Button,
  Radio,
  Input,
  Col,
  DatePicker,
  TimePicker,
  Row, Checkbox,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "../PatientProfileForm/PatientProfileForm.css";
import get from "lodash/get";
import moment from "moment-timezone";
import { getUserTimezone, getUserShortTimezone } from "../../reducers/user/selectors";
import { connect } from "react-redux";
import {getBackendConsentType} from "../../utils/consentUtils";

const { Option } = Select;

const fileDummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

class ConsentStep3b extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );
  }

  render() {
    const props = this.props;


    let isAfterDeferral = props.consentMethodType.includes('AfterDeferral');
    let isRegainedCapacity = props.consentMethodType.includes('RegainedCapacity');


    // todo, this will not be necessary if we pass all the correct data to props from the previous step, we will need to revise all of this
    const backEndType = getBackendConsentType(props.consentPersonType, props.consentMethodType);
    let methodType = 'electronic';
    if (props.consentMethodType.toLowerCase().includes('email')){
      methodType = 'email';
    }
    if (props.consentMethodType.toLowerCase().includes('paper')){
      methodType = 'paper';
    }
    let allowSkipUpload = !props.consent_upload_later && get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.${methodType}.allow_skipping_paper_upload`);

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>
            {props.i18n.t("NamespaceConsent:Paper Consent Process")}
          </h4>
          <h5>
            {props.i18n.t("NamespaceConsent:Site ID")}: <b>{props.siteID}</b>
          </h5>
          <h5>
            {props.i18n.t("NamespaceConsent:User ID")}: <b>{props.userID}</b>
          </h5>
          <h5>
            {props.i18n.t("NamespaceConsent:Subject ID")}: <b>{props.subjectID}</b>
          </h5>
          <h5>
            {props.i18n.t("NamespaceConsent:Consent Type")}: <b>{props.consentPersonType}</b>
          </h5>
          <h5>
            {props.i18n.t("NamespaceConsent:Consent Method")}: <b>{props.consentMethodType}</b>
          </h5>
        </div>
        { !props.form.getFieldValue("consent_upload_later") &&
          <Form.Item>
            {props.form.getFieldDecorator("consentFile", {
              initialValue:
                props.dataset && props.dataset.filename
                  ? props.dataset.filename
                  : [],
              valuePropName: "fileList",
              getValueFromEvent: props.normFile,
              rules: [
                {
                  required: allowSkipUpload ? !props.form.getFieldValue("consent_upload_later") : true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please upload the consent file!"
                  ),
                },
              ],
            })(
              <Upload
                id="consentFile"
                name="consentFile"
                customRequest={fileDummyRequest}
                accept=".pdf"
                allowClear
                size="large"
              >
                <Button>
                  <Icon type="upload" /> {props.i18n.t("NamespaceConsent:Upload Consent Form")}
                </Button>
              </Upload>
            )}
          </Form.Item>
        }


        {allowSkipUpload && <Form.Item>
            {props.form.getFieldDecorator("consent_upload_later", {
            initialValue: false,
            valuePropName: "checked",
          })(
            <Checkbox onChange={() => { setTimeout(() => {props.form.validateFields()}, 0) }}>
              {props.i18n.t(
                "NamespaceConsent:Upload later"
              )}
            </Checkbox>
          )}
        </Form.Item>}

        <div>
          {props.consentPersonType !== "Emergency" && <Form.Item>
            <label>
              <div className="form-label">
                {props.i18n.t(
                  "NamespaceConsent:Please check the appropriate box to indicate your decision"
                )}
                :
              </div>
              {props.form.getFieldDecorator("consent_option", {
                rules: [
                  {
                    required: true,
                    message: props.i18n.t(
                      props.i18n.t("Required")
                    ),
                  },
                ],
              })(
                <Radio.Group>
                  <Radio value="stay_in_study">
                    {props.i18n.t(
                      "NamespaceConsent:I wish to stay in the study."
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study">
                    {props.i18n.t(
                      "NamespaceConsent:I wish to withdraw from the study"
                    )}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>}

          {props.consentPersonType === "Emergency" && <Form.Item>
            <label>
              <div className="form-label">
                {props.i18n.t(
                  "NamespaceConsent:Please check the appropriate box to indicate your decision"
                )}
                :
              </div>
              {props.form.getFieldDecorator("consent_option", {
                rules: [
                  {
                    required: true,
                    message: props.i18n.t(
                      "Required"
                    ),
                  },
                ],
              })(
                <Radio.Group>
                  <Radio value="stay_in_study">
                    {props.i18n.t(
                      "NamespaceConsent:The study physician and independent physician consent to the patient’s enrollment in the study."
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study">
                    {props.i18n.t(
                      "NamespaceConsent:The study physician and independent physician DO NOT consent to the patient’s enrollment in the study."
                    )}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>}

          <Row gutter={8}>
            <Col md={24}>
              <label style={{ display: "block", textAlign: "left" }}>
                {props.i18n.t("NamespaceConsent:Date and time*")}
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px",
                }}
              >
                <Form.Item>
                  <div style={{ width: "150px" }}>
                    {props.form.getFieldDecorator("consent_date_date", {
                      rules: [{ required: true, message: props.i18n.t(
                      "Required"
                    ) }],
                    })(
                      <DatePicker
                        format="YYYY/MM/DD"
                        placeholder="yyyy-mm-dd"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;
                <Form.Item>
                  <div style={{ width: "120px" }}>
                    {props.form.getFieldDecorator("consent_date_time", {
                      rules: [{ required: true, message: props.i18n.t(
                      "Required"
                    ) }],
                    })(
                      <TimePicker
                        format="HH:mm"
                        placeholder="HH:mm"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;&nbsp;
                <Form.Item>
                  {this.props.userShortTimezone ||
                    get(this.props, "site.time_zone") ||
                    "UTC"}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>

        <div>
          <Form.Item>
            {props.form.getFieldDecorator("email_consent_copy_to_subject", {
              initialValue: false,
              valuePropName: "checked",
            })(
              <Checkbox>
                {this.props.i18n.t(
                  "NamespaceConsent:Send copy of consent via email"
                )}
              </Checkbox>
            )}
          </Form.Item>

          {props.form.getFieldValue("email_consent_copy_to_subject") && <div>
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsent:Patient Email"
                  )}
                </div>
                {props.form.getFieldDecorator("consent_subject_email", {
                  initialValue: props.consent_subject_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsent:Please enter the participant's email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("NamespaceConsent:email")}
                  />
                )}
              </label>
            </Form.Item>
          </div>}
        </div>

        <Form.Item>
          <label>
            <div className="form-label">
              {props.i18n.t(
                "NamespaceConsent:Please CONFIRM that the data entered above is correct and complete! If no, please click on the Back button!"
              )}
            </div>
            {props.form.getFieldDecorator("consent_provided", {
              initialValue: props.consent_provided,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please CONFIRM that the data entered above is correct and complete!"
                  ),
                },
              ],
            })(
              <Select>
                <Option value="yes">{props.i18n.t("Yes")}</Option>
                <Option value="">{props.i18n.t("No")}</Option>
              </Select>
            )}
          </label>
        </Form.Item>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

export default withNamespaces()(connect(mapStateToProps)(ConsentStep3b));



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWorkflowV2_1/ConsentStep3b.js